import { TimePickerProps as MUITimePickerProps, TimePicker } from '@mui/x-date-pickers';

export interface TimePickerProps extends MUITimePickerProps<Date> {}

const BasicTimePicker = (props: TimePickerProps) => {
  const { ...rest } = props;
  return <TimePicker {...rest} />;
};

export { BasicTimePicker };

BasicTimePicker.displayName = 'Basic Time Picker';
